/* ============================================================================
   section-bd-footer.js — Footer color dots (persistent theme switcher).
   Builds a compact row of the 7 brand-color dots from window.BiiniiTheme
   (biinii-color-theme.js, the single source of truth for the 7-color system)
   and wires them to the SAME engine as the home's «Which color are you?».
   Both selectors stay in sync via the global `biinii:theme` event + the
   shared localStorage choice. Progressive enhancement: without JS (or before
   the engine loads) the region stays [hidden] and the footer is fully usable.
   ============================================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function build(region) {
    if (!region || region.dataset.bdFooterThemeReady) return;
    var Theme = window.BiiniiTheme;
    if (!Theme) return; // engine not loaded yet; retry on the events below

    var holder = region.querySelector('[data-bd-footer-dots]');
    if (!holder) return;
    region.dataset.bdFooterThemeReady = '1';

    var COLORS = Theme.COLORS;
    var KEYS = Theme.KEYS;
    var dots = {};

    KEYS.forEach(function (key) {
      var c = COLORS[key];
      if (!c) return;
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'bd-footer__dot';
      dot.style.background = c.hex;
      dot.setAttribute('aria-label', c.n);
      dot.setAttribute('aria-pressed', String(Theme.current() === key));
      dot.dataset.bdThemeKey = key;
      dot.addEventListener('click', function () { Theme.toggle(key); });
      holder.appendChild(dot);
      dots[key] = dot;
    });

    function sync(activeKey) {
      KEYS.forEach(function (key) {
        if (dots[key]) dots[key].setAttribute('aria-pressed', String(key === activeKey));
      });
    }

    document.addEventListener('biinii:theme', function (e) {
      sync(e.detail && e.detail.key);
    });

    // Reveal now that the dots exist (hidden in markup so no-JS shows nothing).
    region.removeAttribute('hidden');
  }

  function boot() {
    document.querySelectorAll('[data-bd-footer-theme]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme engine may announce itself after this script runs; re-attempt.
  document.addEventListener('biinii:theme', boot);
  document.addEventListener('shopify:section:load', boot);
})();
